import { render, staticRenderFns } from "./GFCompanyDashboard.vue?vue&type=template&id=5ffba0a0&scoped=true"
import script from "./GFCompanyDashboard.vue?vue&type=script&lang=js"
export * from "./GFCompanyDashboard.vue?vue&type=script&lang=js"
import style0 from "./GFCompanyDashboard.vue?vue&type=style&index=0&id=5ffba0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffba0a0",
  null
  
)

export default component.exports